const isBrowser = typeof document !== "undefined"

export const handleOverflow = (state) => {
  if(isBrowser) {
    // retrieve body element in order to disabled scrolling on body if menu is open
    let body = document.getElementsByTagName('body')[0]
    // apply the styles based on menu state
    if (state) body.style.overflow = 'hidden'
    else body.style.overflow = 'auto'
  }

}